/**
 * useAuth — returns current access token for API calls.
 * Reads from store only; token is set once in userContext (initializeWithCreToken / initializeWithRadicalToken).
 * Avoids each component calling getAccessToken() → acquireTokenSilent (which caused token endpoint loop).
 */
import { useGlobalStore } from "../context/UserContext/userContext";

export const useAuth = () => {
  return useGlobalStore((s) => s.accessToken);
};
